export interface User {
  _id: string;
  name: string;
  email: string;
  password?: string;
  role: string;
  avatar?: null | string;
}

export interface IUserEmail {
  email: string;
  subject: string;
  body: string;
}

interface CreateUserAction {
  type: UserActionTypes.CREATE_USER;
  payload: User;
}

interface DeleteUserAction {
  type: UserActionTypes.DELETE_USER;
  payload: string;
}

interface UpdateUserAction {
  type: UserActionTypes.UPDATE_USER;
}

export interface ClearUserAction {
  type: UserActionTypes.CLEAR_USER;
}

interface UserLoadingAction {
  type: UserActionTypes.USERS_LOADING;
}

interface BtnLoadingAction {
  type: UserActionTypes.BTN_LOADING;
  payload: boolean;
}

interface GetAllUsersAction {
  type: UserActionTypes.GET_ALL_USERS;
  payload: any[];
}

export enum UserActionTypes {
  USERS_LOADING = 'USERS_LOADING',
  GET_ALL_USERS = 'GET_ALL_USERS',
  CLEAR_USER = 'CLEAR_USER',
  UPDATE_USER = 'UPDATE_USER',
  CREATE_USER = 'CREATE_USER',
  DELETE_USER = 'DELETE_USER',
  BTN_LOADING = 'BTN_LOADING'
}

export interface UserState {
  users: any[];
  loading: boolean;
  btnLoading: boolean;
}

export type UserAction =
  | UserLoadingAction
  | GetAllUsersAction
  | ClearUserAction
  | UpdateUserAction
  | CreateUserAction
  | BtnLoadingAction
  | DeleteUserAction;
